module.exports = __webpack_public_path__ + "static/img/穿防护鞋.d06896f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/穿防护鞋.png
// module id = E/2J
// module chunks = 1